import axios from "axios";
import { getBaseUrl } from "../components/supastore";

const social_api = axios.create({
    baseURL: `${getBaseUrl()}/api/social/`,
})

export {
    social_api
}